<template>
	<div class="ReSearchObjMap">
		<yandex-map
			:settings="yamap_settings"
			:coords="yamap_coords"
			:zoom="yamap_zoom"
			:controls="yamap_controls"
			:scroll-zoom="true"
			>
				
				<ymap-marker v-for="marker in yamap_markers" :key="marker.id"
					:coords="marker.coords"
					:marker-id="marker.id"
					:icon="marker.markerIcon"
					:balloon-template="marker.balloonTemplate"
				/>
		</yandex-map>
		<!--pre style="max-width:1000px;">{{objData}}</pre-->
	</div>
</template>

<script>
	import { yandexMap, ymapMarker } from 'vue-yandex-maps';
	import mapSettings from 'src/conf/yandexmap.js';
	export default {
		name: 'ReSearchObjMap',
		components: { 
			yandexMap, 
			ymapMarker
		},
		props: {
			objData: [Object,Array]
		},
		data () {
			return {
				ver: 1,
				yamap_settings: { ...mapSettings	},
				yamap_coords: [59.93984485554249, 30.314527237792984],
				yamap_zoom: 11,
				yamap_controls:['zoomControl','typeSelector'],
				yamap_markers:[],
			}
		},
		watch: {
			objData(val){
				this.makeMarkers();
			}
		},
		methods: {
			makeMarkers(){
				this.yamap_markers = [];
				const objGetParams = this.$GVO.GetAllGet();
				for (let i = 0; i < this.objData.length; i++) {
					const objComplex = this.objData[i];
					let strImg = '/img/icons/map/map_icon_ready.svg';
					if(new Date(objComplex.b_endingperiod_min) <= Date.now()) {
						strImg = '/img/icons/map/map_icon_ready.svg';
					} else{
						strImg = '/img/icons/map/map_icon_inprog.svg';
					}
					let strConstGetParams = '';
					if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
						strConstGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
					}
					//let strComplexUrl = '/data/module/sso/object/complex/'+objComplex.gk_name_tr+strConstGetParams;
					let strComplexUrl = '/data/module/sso/object/complex/'+objComplex.PK+strConstGetParams;
					let strComplexImg = '/DATA/complex_files/NewComplexFiles_350_X/'+objComplex.gk_avatar;
					this.yamap_markers.push({
						id: i,
						coords: [objComplex.gk_lat, objComplex.gk_lot],
						markerIcon: {
							layout: 'default#imageWithContent',
							imageHref: strImg,
							imageSize: [33, 40],
							imageOffset: [-18, -35],
						},
						balloonTemplate: `
							<div class="cardComplex" style="height: auto !important;">

								<div class="img">
									<!--div class="tags">
										<div class="tag">Ипотека</div>
									</div-->
									<a href="${strComplexUrl}">
										<img alt="ЖК ${objComplex.gk_name}" title="Жилой комплекс ${objComplex.gk_name}" src="${strComplexImg}">
									</a>
								</div>
												
								<div class="objInfo">
									<div class="complexName"><a href="${strComplexUrl}">ЖК: ${objComplex.gk_name} (подробнее о ЖК)</a></div>
									<div class="dev"><p>Застройщик: ${objComplex.dev_name}</p></div>	
									<div class="price"><p>Цена: от ${this.$GVO.formatAmount(parseFloat(objComplex.min_amount_on_sale))}</p></div>
									<div class="flatCount">Квартир: ${objComplex.countflat_onsale}</div>									
									

									<div class="address">
										<div class="metroPathTime">
											<i class="tim-ic ic-metro mr-2 text-primary"></i>
											<p class="">${objComplex.metro_name}</p>
										</div>
										<div class="districtStreet">
											<i class="tim-icons icon-square-pin mr-2 text-primary"></i>
											<span class="addr-icon">${objComplex.dis_name}, ${objComplex.gk_street}</span>
										</div>
									</div>
									<div class="dopInfo d-none">
										<div>Срок сдачи: ${this.$GVO.convertDateFromMysql(objComplex.b_endingperiod_min)}</div>
										<div>${objComplex.b_decoration_list}</div>
										<div>${objComplex.b_buildingtypes}</div>
									</div>
								</div>

									
							</div>
						`
					});
				}
			}
		},
		mounted() {
			this.makeMarkers();
		}
	}
</script>
<style>
	.ymap-container{height: 600px; width: 100%;}
	.ReSearchObjMap{position: relative; width: 100%;}
	.cardComplex .img{
		width: 100%;
		margin: 0 auto;
    	display: flex;
		margin-bottom: 15px;
		padding-top: 15px;
	}
	.cardComplex .img img{max-width: 300px; object-fit: cover;}
	.cardComplex .img a{display: inline-block; margin: 0 auto;}
	.cardComplex p {color: #000;}
	.complexName {margin-bottom: 5px;}
	.metroPathTime, .districtStreet {display: flex; align-items: center;}
	.objInfo {padding: 0px 10px;}
	.flatCount {margin-bottom: 5px;}
	.ymaps-2-1-77-balloon__content{
		margin-right: 0px!important;
		padding: 20px!important;
	}
	/*===media===============================*/
	@media (max-width: 768px) {	
		.ymap-container {height: 450px;}
	}
</style>
